import React from 'react';

import { ReactComponent as PublicisMediaLogo } from '../../../assets/svg/logo_publicismedia.svg';
import { default as t } from '../../../utils/i18n';
import { ActionLink } from '../../atoms';
import config from '../../../utils/config';

import './footer.scss';

const HELP_SUPPORT_LINK = config.get('help', 'support_link');
const HELP_LINK = config.get('help', 'support_url');

const Footer = ({ interstitial }) => {
  return (
    <>
      <div className="c-footer">
        <div className={`container ${interstitial ? 'interstitial-container' : ''}`}>
          <div className="row">
            <div className={`col-lg-3 ${interstitial ? 'col-offset-md-01' : 'col-offset-md-1'}`}>
              <div className="c-text-heading-3">
                <ActionLink
                  anchor={true}
                  href={HELP_SUPPORT_LINK.replace(
                    /\{(.*?)\}/gi,
                    t('dashboard.link.helpAndSupport', true)
                  )}
                  value={t('dashboard.link.helpAndSupport')}
                />{' '}
                (PDF)
              </div>
              <ActionLink
                anchor={true}
                href={HELP_LINK}
                value={t('dashboard.link.support')}
              ></ActionLink>
              <p className="c-text-heading-4 mb-50 copy-right">
                {t('dashboard.footer.copyrightText')}
              </p>
            </div>
            <div className={`col-lg-1 ${interstitial ? 'col-offset-md-07' : 'col-offset-md-7'}`}>
              <PublicisMediaLogo className="c-footer-logo" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Footer;
